module.exports = __webpack_public_path__ + "img/TEAMModellogo_en.473efe81.png";